/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */
// baki

import React, { useState, useEffect, useContext } from 'react';
import Alert from 'react-s-alert';
import { Table, Progress, Pagination, PaginationItem, PaginationLink, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import moment from 'moment';
import { Link, useLocation } from 'react-router-dom';

// context imports
import { ThemeContext } from '../../../contexts/ThemeContext';
import { AuthContext } from '../../../contexts/AuthContext';

// service imports
import ProviderService from '../../../services/ProviderService';
import GeneralService from '../../../services/GeneralService';

// local imports
import UserNotApproved from './UserNotApproved';
import Message from '../../general/Message';
import ErrorBoundary from '../../general/ErrorBoundary';
import ProviderNavbar from './ProviderNavbar';
import Loading from '../../../assets/UW_Horizontal_Logo_Full.png';

const ProviderSubscriptionDetails = props => {


    // contexts
    const { theme, fontWeight, colors } = useContext(ThemeContext);
    const { user, setUser, selectedTimeZone, userApprovalStatus } = useContext(AuthContext);

    // states


    // useEffects


    // utility functions
 



    // handle functions


    // function's return

  

    return (
        <div>
            <ProviderNavbar history={props.history} />
            
            {/* {console.log('State', props.location.state)} */}
            
        </div >
    )

}

export default ProviderSubscriptionDetails;